export default "__VITE_ASSET__ByIrq3FM__"